import React from 'react';
import ReactDOM from 'react-dom';

import { contextLoader } from '../common/services/context-loader';
import Wix from '../common/services/wix-sdk-polyfill';
import Container from './container';
import { reducer } from './state';
import { ROOT_ID } from '../common/constants/dom';
import listenToMemberChange from '../common/services/listen-to-member-change';
import { createRoleFilterChangeMiddleware } from './state/middleware/role-filter';

const { store, i18n, fedops } = contextLoader({ reducer, middlewaresToAdd: [createRoleFilterChangeMiddleware()] });

listenToMemberChange(store);

ReactDOM.render(<Container store={store} i18n={i18n} />, document.querySelector(`#${ROOT_ID}`), () => {
  Wix.Performance.applicationLoaded();
  fedops.appLoaded();
});
